import { BaseViewStore} from 'core/stores';
import { action, observable } from "mobx";

class PickTicketRefreshConfirmationModalStore extends BaseViewStore {
	@observable accessor isLoading = false;
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.isInProgres = this.modalParams.data.isInProgres;
        this.hasBackOrder = this.modalParams.data.hasBackOrder;
    }

    @action.bound
    async refreshPickTicket() {
        this.isLoading = true;
        try {
            await this.modalParams.data.refreshPickTicket();
            this.modalParams.close();
        }
        catch (err) {
            return this.onUpdateError(err);
        }
        this.isLoading = false;
    }
}

export default PickTicketRefreshConfirmationModalStore;
